import { createFileRoute } from '@tanstack/react-router';
import TrialDecorationLayout from '@/features/agent/trial/layouts/TrialDecorationLayout';
import TrialAccountLinkTemplate from '@/features/agent/trial/templates/TrialAccountLinkTemplate';

export const Route = createFileRoute('/agent/trial/account/link/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TrialDecorationLayout>
      <TrialAccountLinkTemplate />
    </TrialDecorationLayout>
  );
}
